<!--  -->
<template>
	<div class="content">
		<cx-head v-if="windowWidth <= 768" />
		<b-container fluid>
			<img class="top_img" width="100%" src="../../static/img/about/top_img.png" />
			<img class="top_img1" width="100%" src="../../static/img/about/top_img.png" />
		</b-container>
		<div class="mianbao" toggleable="lg" :class="{ isFixed: isFixed }" ref="obtain">
			<div class="mianbao_view">
				<div v-for="(item, index) in mianbaoList" :key="index" class="mianbao_item"
					@click="goAnchor(item.id, index)" :class="{ active: index == tabCur }">{{ item.label }}</div>
			</div>
			<div class="mianbao_min">
				<div style="width: 90px;" v-for="(item, index) in mianbaoList1" :key="index" :class="{ active: index == tabCur }"
					@click="goAnchor(item.id, index)">{{ item.label }}</div>
			</div>
		</div>

		<div class="about_view" id="title1">
			<h4 class="title_text">公司简介</h4>
			<p class="about_text" style="text-indent: 2em;">
			快乐车行（北京）科技有限公司是一家综合性的旅游服务企业，已获得高新技术企业认定，是全国工商联汽车经销商商会房车露营专委会会长单位、中国旅游车船协会自驾游与露营房车分会理事单位。公司致力于为旅游者提供旅游产品及服务，特别是房车旅游服务。业务涉及房旅线路定制、房车自驾游、研学游学旅游、夏令营、团建旅游、营地户外休闲旅游、会务活动策划和定制服务、沉浸式旅游服务等，旅游目的地遍及全球。
			成立以来，公司承接的多次大型自驾旅游线路获得业界好评。公司实时跟进行业在新能源房车、无人驾驶房车、AI技术上的探索和发展，通过硬件迭代和服务升级，为用户的房旅生活实现更多拓展场景应用，提高房车旅居舒适度。
			当前，公司正在不断拓展旅游产品外延，积极探索旅游与文化、康养、农业、体育、生态等的深度融合，创新业务，力争推出更多新内容、新产品、新线路，满足游客的多元化需求。
			</p>
		</div>


		<div class="about_view" id="title4">
			<h4 class="title_text">管理团队</h4>
			<div class="manageTeam">
				<div class="manage_item" v-for="(item, index) in TeamData" :key="index">
					<img class="teamImg" :src="item.Photo" />
					<div class="manageName">{{ item.Name }}</div>
					<div class="manageJob">{{ item.JobDescription }}</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
	//例如：import 《组件名称》 from '《组件路径》';
	import api from '../api/api.js';
	import cxHead from '@/components/cx-head.vue';
	export default {
		//import引入的组件需要注入到对象中才能使用
		components: {
			cxHead,
		},
		metaInfo() {
			return {
				title: this.pageName, // set a title
				meta: [
					{
						// set meta
						name: 'keyWords',
						content: this.SeoKeyword,
					},
					{
						name: 'description',
						content: this.SeoDescription,
					},
				],
			};
		},
		data() {
			//这里存放数据
			return {
				isFixed: false,
				windowWidth: window.innerWidth,
				pageName: '',
				SeoKeyword: '',
				SeoDescription: '',
				tabCur: 0,
				mianbaoList: [
					{
						label: '公司简介',
						path: '#',
						id: '#title1',
					},

					{
						label: '管理团队',
						path: '#',
						id: '#title4',
					},

				],
				mianbaoList1: [
					{
						label: '公司简介',
						path: '#',
						id: '#title1',
					},

					{
						label: '管理团队',
						path: '#',
						id: '#title4',
					},

				],
				yearCur: 0,
				historyData: [],//发展历程
				TeamData: [],//管理团队
				HonorsData: [],//荣誉证书
				swiperOption: {
					// autoplay: {
					// 	disableOnInteraction: false,
					// 	delay: 500,
					// },
					slidesPerView: window.innerWidth >= 768 ? 5 : 1.3,
					spaceBetween: window.innerWidth >= 768 ? 76 : 10,
					slidesOffsetBefore: window.innerWidth >= 768 ? 240 : 20,
					grabCursor: true,
					// slidesPerView: 1,
					// loop: true,
					// width: 1040,
					// navigation: {
					// 	nextEl: '.swiper-button-next',
					// 	prevEl: '.swiper-button-prev',
					// },
					// pagination: {
					// 	el: ".swiper-pagination",
					// 	type: "fraction",
					// },
				},
				swiperOption1: {
					// autoplay: {
					// 	disableOnInteraction: false,
					// 	delay: 500,
					// },
					// grid: {
					// 	rows: 3,
					// },
					// slidesPerColumn: 3,
					slidesPerView: 2.1,
					spaceBetween: 10,
					slidesPerColumnFill: 'row',
					// height:690
					// slidesPerView: 1,
					// loop: true,
					// width: 1040,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					// pagination: {
					// 	el: ".swiper-pagination",
					// 	type: "fraction",
					// },
				},
			};
		},

		//监听属性 类似于data概念
		computed: {},
		//监控data中的数据变化
		watch: {},
		//方法集合
		methods: {

			goto(e) {//跳转外部链接
				window.open(e, '_blank');
				// window.location.href = e;
			},

			Scroll(e) {
				let that = this;
				let scrollTop = e.target.documentElement.scrollTop || e.target.body.scrollTop;
				console.log(scrollTop);
				let mianbaoTop = that.$refs.obtain.getBoundingClientRect().top;
				console.log('距离顶部高度', mianbaoTop)
				if (scrollTop > 620 && that.windowWidth > 768) {
					that.isFixed = true;
					if (scrollTop < 1000) {
						that.tabCur = 0
					}
					else if (1000 <= scrollTop && scrollTop < 1400) {
						that.tabCur = 1
					}
					else if (1400 <= scrollTop && scrollTop < 2340) {
						that.tabCur = 2
					}
					else if (2340 <= scrollTop && scrollTop < 4800) {
						that.tabCur = 3
					} else if (4800 <= scrollTop && scrollTop < 5820) {
						that.tabCur = 4
					} else if (5820 <= scrollTop) {
						that.tabCur = 5
					}
				} else if(scrollTop > 300 && that.windowWidth <= 768) {
					that.isFixed = true;
				}else{
					that.isFixed = false;
				}
			},

			formatDate(date) { //格式化日期
				if (date) {
					let date1 = new Date(date.replace(/-/g, '/'));
					date = this.common.formatDate(new Date(date1), 'MM月dd日');
				}
				return date;
			},

			dateFormort(dateStart) {
				let date = new Date(dateStart.replace(/-/g, '/'));
				return date;
			},

			getSiteData() {
				//获取seo关键字
				let that = this;
				that.$axios
					.post(api.GetSiteData, {})
					.then(function (response) {
						// console.log('seo优化', response);
						let data = response.data;
						that.pageName = data.Title ? data.Title : '约你游·一站式房车旅游综合服务平台';
						that.SeoKeyword = data.SeoKeyword ? data.SeoKeyword : '约你游·一站式房车旅游综合服务平台';
						that.SeoDescription = data.SeoDescription
							? data.SeoDescription
							: '约你游·一站式房车旅游综合服务平台';
					})
					.catch(function (error) {
						console.log(error);
					});
			},
			goAnchor(selector, index) {
				// debugger
				this.tabCur = index;
				//跳转锚点
				var anchor = this.$el.querySelector(selector); // 参数为要跳转到的元素id
				document.body.scrollTop = anchor.offsetTop; // chrome
				document.documentElement.scrollTop = anchor.offsetTop; // firefox
			},

			getHistoryPageData() {//获取发展历程
				let that = this;
				this.$axios
					.post(api.GetHistoryPageData, { wheres: "[{ name: 'Type', value:'1' }]" })
					.then(function (response) {
						let data = response.data;
						that.historyData = data;
					})
					.catch(function (error) {
						console.log(error);
					});
			},
			getCompanyTeamData() {//获取管理团队
				let that = this;
				this.$axios
					.post(api.GetCompanyTeamData, { page: 1, rows: 99, sort: 'Sort,CreateDate' })
					.then(function (response) {
						let data = response.data.rows;
						that.TeamData = data;
					})
					.catch(function (error) {
						console.log(error);
					});
			},
			getCorporateHonorsData() {//获取荣誉证书
				let that = this;
				this.$axios
					.post(api.GetCorporateHonorsData, { page: 1, rows: 99, sort: 'Sort,CreateDate' })
					.then(function (response) {
						// debugger
						let data = response.data.rows;
						that.HonorsData = data;
					})
					.catch(function (error) {
						console.log(error);
					});
			},

		},
		//生命周期 - 创建完成（可以访问当前this实例）
		created() {
			this.getHistoryPageData();
			this.getCompanyTeamData();
			this.getCorporateHonorsData();
		},
		//生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {
			window.addEventListener('scroll', this.Scroll, true);
			this.getSiteData();
		},
		beforeCreate() { }, //生命周期 - 创建之前
		beforeMount() { }, //生命周期 - 挂载之前
		beforeUpdate() { }, //生命周期 - 更新之前
		updated() { }, //生命周期 - 更新之后
		beforeDestroy() { }, //生命周期 - 销毁之前
		destroyed() { }, //生命周期 - 销毁完成
		activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
	};
</script>
<style lang='scss' scoped>
	//@import url(); 引入公共css类
	.content {
		padding-bottom: 90px;
	}

	.container-fluid {
		padding-left: 0 !important;
		padding-right: 0 !important;
	}

	.mianbao {
		background: #fbfbfb;
		font-size: 16px;
		// padding: 15px 0;
		padding-top: 15px;
	}

	.isFixed {
		position: fixed;
		top: 0;
		width: 100%;
		z-index: 9999;
	}

	.mianbao_view {
		max-width: 1460px;
		width: 100%;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.content_text {
		flex: 1;
	}


	@media (min-width: 768px) {
		.mianbao_min {
			display: none;
		}

		.top_img1 {
			display: none;
		}

		.top_img {
			display: block;
		}


		.about_text {
			color: #222222;
			font-size: 1.1rem;
			line-height: 2.4;
			text-align: left;
			margin-top: 50px;
		}

		.manageTeam {
			max-width: 1440px;
			width: 100%;
			display: flex;
      justify-content: space-around;
			list-style: none;
			// width: 970px;
			flex-wrap: wrap;
			margin: 0 auto;
			margin-top: 20px;
			padding: inherit;
			text-align: left;
			color: #222;

			.manage_item {
				width: 16%;
				// padding: 0 20px;
				margin-top: 20px;

				.teamImg {
					width: 220px;
					height: 220px;
				}

				.manageName {
					font-size: 24px;
					margin-top: 30px;
					font-weight: bold;
					font-family: 'zxhjt';
					font-style: oblique;
				}

				.manageJob {
					margin-top: 19px;

				}

				img {
					width: 100%;
					height: auto;
					border-radius: 10px;

				}
			}
		}

		.history_view {
			background: url('../../static/img/about/yearImg.png') no-repeat;
			width: 100%;
			height: auto;
			background-size: 100% auto;
			background-position: center center;
			padding: 70px 0;
			padding-top: 80px;
			padding-bottom: 124px;

			.year_view {
				flex-direction: row;
				display: flex;
				align-items: center;
				width: 100%;
				max-width: 900px;
				margin: 0 auto;
				color: #fff;
				margin-top: 60px;
				overflow-x: auto;
				justify-content: space-between;
				font-size: 16px;
				/* .year_item{
					margin: 0 40px;
					cursor: pointer;
				} */

			}

			.xian {
				width: 100%;
				max-width: 844px;
				height: 3px;
				background-color: rgba(239, 239, 239, 0.3);
				position: absolute;
				left: 50%;
				margin-left: -422px;
				margin-top: 33px;
				z-index: 1;
			}

			.content_list {
				color: #fff;
				width: 100%;
				max-width: 900px;
				border-radius: 10px;
				background: rgba(0, 0, 0, 0.4);
				height: 500px;
				/* overflow-y: auto; */
				padding: 55px 25px 55px 65px;
				margin: 0 auto;
				margin-top: 100px;

				.content_xq {
					height: 390px;
					overflow-y: auto;
				}

				.content_item {
					display: flex;
					flex-direction: row;
					text-align: left;
					margin-bottom: 40px;
					padding-right: 60px;
				}
			}
		}

		.honor_view {
			// background: url('../../static/img/about/gg_bg.png') no-repeat;
			width: 100%;
			height: auto;
			// background-size: 100% auto;
			background-position: center center;
			padding: 70px 0;
			// padding-top: 84px;
			// padding-bottom: 70px;
			margin-top: 80px;
			background-color: #fbfbfb;

			.honorList {
				display: flex;
				width: 100%;
				max-width: 1440px;
				flex-wrap: wrap;
				margin: 0 auto;
				// margin-top: 20px;
				padding: inherit;
				text-align: center;
				color: #222;
				// justify-content: space-between;
			}

			.honor_item {
				width: 246px;
				margin-top: 20px;
				margin-right: 104px;

				.honorText {
					margin-top: 19px;
				}

				.honorImg {
					width: 100%;
					height: 186px;
					margin-top: 40px;
					border: 2px solid #DAC870;
					padding: 3px;
				}

			}

		}

		.honorImg:nth-child(2n) {
			margin-left: 150px;
		}

		.live_view {
			.title_text {
				text-align: left;
				max-width: 1440px;
				margin: 0 auto;
			}
		}

		.live_box {
			display: flex;
			flex-direction: row;
			margin-top: 40px;

			.live_item {
				flex: 1;
				position: relative;

				.point {
					position: absolute;
					top: 50%;
					left: 50%;
					margin-left: -88px;
					margin-top: -31px;
					animation: zoom 1s infinite ease-in-out;
					-webkit-animation: zoom 1s infinite ease-in-out;
					cursor: pointer;
				}

				@keyframes zoom {
					0% {
						transform: scale(1);
					}

					50% {
						transform: scale(1.1);
					}

					100% {
						transform: scale(1);
					}
				}
			}
		}
	}

	@media (max-width: 768px) {
		.about_view {
			margin-top: 30px !important;
		}

		.mianbao_min {
			display: -webkit-box;
			height: 40px;
			line-height: 35px;
			background-color: #FBFBFB;
			width: 100%;
			/* justify-content: space-around; */
			text-align: center;
			font-size: 14px;
			overflow-x: auto;
		}

		.vision_view {
			display: none;
		}

		.vision_view1 {
			display: block;
			margin: 0 25px;
			margin-top: 30px;

			img {
				width: 100%
			}
		}

		#tt3 {
			display: none !important
		}

		.top_img {
			display: none;
		}

		.mianbao_item {
			flex: 1;
		}

		.mianbao {
			padding-top: 0;
		}

		.mianbao_view {
			display: none;
		}

		.about_text {
			color: #222222;
			font-size: 14px;
			padding: 0 15px;
			text-align: left;
			margin-top: 20px;
		}

		.manageTeam {
			// max-width: 1440px;
			width: 100%;
			display: flex;
			list-style: none;
			// width: 970px;
			flex-wrap: wrap;
			margin: 0 auto;
			padding: inherit;
			text-align: left;
			color: #222;
			padding: 0 15px;
			justify-content: space-between;

			.manage_item {
				width: 49%;
				// padding: 0 20px;
				margin-top: 20px;
				text-align: center;

				.teamImg {
					width: 100%;
					// height: auto;
					height: 180px;
				}

				.manageName {
					font-size: 18px;
					margin-top: 15px;
					font-weight: bold;
					font-family: 'zxhjt';
					font-style: oblique;
					text-align: left;
				}

				.manageJob {
					margin-top: 10px;
					text-align: left;
				}

				img {
					width: 100%;
					height: auto;
					border-radius: 10px;

				}
			}
		}

		.honor_view {
			// background: url('../../static/img/about/gg_bg.png') no-repeat;
			width: 100%;
			height: auto;
			// background-size: 100% auto;
			// background-position: center center;
			padding: 30px 15px;
			// padding-top: 84px;
			// padding-bottom: 70px;
			margin-top: 20px;
			background-color: #fbfbfb;

			.honorList {
				display: flex;
				width: 100%;
				// max-width: 1440px;
				flex-wrap: wrap;
				margin: 0 auto;
				margin-top: 20px;
				padding: inherit;
				text-align: center;
				color: #222;
				justify-content: space-between;
				// padding: 0 15px;
			}

			.honor_item {
				width: 49%;
				/* margin-top: 20px; */
				// margin-right: 104px;

				.honorText {
					margin-top: 13px;
					font-size: 12px;
				}

				.honorImg {
					width: 100%;
					height: 127px;
					// margin-top: 20px;
					border: 2px solid #DAC870;
					padding: 3px;
				}

			}

		}

		.active {
			border-bottom: 2px solid #0C8C69;
			color: #0C8C69;
			// font-weight: bold;
		}

		.history_view {
			background: url('../../static/img/about/yearImg1.png') no-repeat;
			width: 100%;
			height: auto;
			background-size: 100% auto;
			background-position: center center;
			padding: 45px 0;
			margin-top: 40px;

			.year_view {
				flex-direction: row;
				display: flex;
				align-items: center;
				margin: 0 35px;
				color: #fff;
				margin-top: 20px;
				overflow-x: auto;
				justify-content: space-between;
				font-size: 12px;

				.year_item {
					margin: 0 15px;
				}
			}

			.xian {
				width: 100%;
				max-width: 305px;
				height: 3px;
				background-color: rgba(239, 239, 239, 0.5);
				position: absolute;
				left: 50%;
				margin-left: -152px;
				margin-top: 27px;
				z-index: 1;
			}

			.content_list {
				font-size: 12px;
				color: #fff;
				/* width: 100%; */
				/* max-width: 900px; */
				border-radius: 10px;
				background: rgba(0, 0, 0, 0.4);
				height: 405px;
				/* overflow-y: auto; */
				padding: 30px;
				margin: 0 35px;
				margin-top: 37px;

				.content_xq {
					height: 345px;
					overflow-y: auto;
				}

				.content_item {
					display: flex;
					flex-direction: row;
					text-align: left;
					margin-bottom: 25px;
				}
			}
		}
		.live_view {
			.title_text {
				text-align: left;
				margin-left: 20px;
			}
		}
		.live_box {
			margin-top: 20px;

			.live_item {
				flex: 1;
				position: relative;

				.point {
					position: absolute;
					top: 50%;
					left: 50%;
					margin-left: -44px;
					margin-top: -16px;
					animation: zoom 1s infinite ease-in-out;
					-webkit-animation: zoom 1s infinite ease-in-out;
				}

				@keyframes zoom {
					0% {
						transform: scale(1);
					}

					50% {
						transform: scale(1.1);
					}

					100% {
						transform: scale(1);
					}
				}
			}
		}
	}

	.mianbao_item {
		margin: 0 20px;
		cursor: pointer;
		padding-bottom: 15px;
	}

	.active {
		border-bottom: 2px solid #0C8C69;
		// font-weight: bold;
	}

	@media (min-width: 768px) {
		.about_view {
			margin: 40px auto;
			font-size: 14px;
			width: 100%;
			max-width: 1440px;
			margin-top: 40px;
		}

		.vision_view1 {
			display: none;
		}

		.vision_view {
			width: 100%;
			// height: 740px;
			max-width: 1440px;
			margin: 0 auto;
			margin-top: 150px;
			margin-bottom: 40px;

			img {
				width: 100%;
				height: auto;
			}
		}

		.content_xq::-webkit-scrollbar {
			border-radius: 10px;
			width: 10px;
			height: 10px;
			background-color: #ffff;
			display: block !important;
		}

		::-webkit-scrollbar-thumb {
			border-radius: 10px;
			/* -webkit-box-shadow: inset 0 0 6px #c4aae4; */
			height: 10px;
			background-color: #fff;
		}

		::-webkit-scrollbar-track {
			/* -webkit-box-shadow: inset 0 0 6px #fff; */
			border-radius: 10px;
			background-color: #ccc;
		}

	}
</style>



// WEBPACK FOOTER //
// src/page/about.vue